<template>
  <div class="notice-popup">
    <transition name="scale-in" @after-leave="closeDialog">
      <div v-if="showContent" class="container">
        <div class="container-wrapper">
          <div
            class="content-wrap"
            v-for="(item, index) in noticeList"
            :key="index"
            :class="{ active: index + 1 == activePage }"
            :value="index"
          >
            <p class="title">{{ item.title }}</p>
            <p class="content">
              {{ item.content }}
            </p>
          </div>
          <div class="pagination" v-if="noticeList.length > 1">
            <span
              v-for="item in noticeList.length"
              :key="item"
              :class="{ active: item == activePage }"
              class="page"
              @click="updatePage(item)"
              >{{ item }}</span
            >
          </div>
          <div class="btn-wrap">
            <div class="btn cancel" @click="closePopup">
              {{ languages.passIKonw }}
            </div>
            <div class="btn confirm" @click="openService">
              {{ languages.passGoOn }}
            </div>
          </div>
        </div>
        <div class="close-btn account" @click="closePopup"></div>
      </div>
    </transition>
    <transition name="fade-in">
      <div v-if="showContent" @click="hideContent" class="bg"></div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ['languages', 'noticeList'],
  data() {
    return {
      showContent: false,
      operateType: '',
      activePage: 1
    };
  },
  methods: {
    closeDialog() {
      if (this.operateType === 'closePopup') {
        this.$emit('closePopup');
      }
      if (this.operateType === 'openService') {
        this.$emit('openService');
      }
      this.$emit('closePopup');
    },
    hideContent() {
      this.showContent = false;
    },
    closePopup() {
      this.operateType = 'closePopup';
      this.hideContent();
    },
    openService() {
      this.operateType = 'openService';
      this.hideContent();
    },
    updatePage(page) {
      this.activePage = page;
    }
  },
  mounted() {
    this.showContent = true;
  },
  beforeDestroy() {
    this.showContent = false;
    window.setHasGlobalDialog(false)
  },
  created() {
    window.setHasGlobalDialog(true)
    window.globalHideDialogCb = this.hideContent
  },
};
</script>

<style scoped lang="scss">
$dialogW: 550px;
$dialogH: 308px;
.notice-popup {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.container {
  position: relative;
  width: 650px;
  min-height: $dialogH;
  background: white;
  z-index: 10;
}
.container-wrapper {
  background: #fff;
  padding: 14px;
}

.title {
  font-size: 23.6px;
  text-align: center;
  color: #414141;
  margin-top: 25px;
  margin-bottom: 25px;
}

.content {
  font-size: 22px;
  text-align: center;
  color: #414141;
  line-height: 30px;
}

.content-wrap {
  display: none;
  min-height: 140px;
  &.active {
    display: block;
  }
}

.btn-wrap {
  display: flex;
  justify-content: space-between;
  width: 80%;
  margin: 20px auto;
  .btn {
    font-size: 23.6px;
    width: 221px;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: #5fd193;
    color: #fff;
    &.confirm {
      background-color: #a4a4a4;
    }
  }
}

.pagination {
  display: flex;
  justify-content: flex-end;
  margin: 30px 0;
  .page {
    display: inline-block;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 25px;
    color: #808090;
    background: #d9d9d9;
    opacity: 0.8;
    &.active {
      opacity: 1;
      color: #000;
      background: #f2f2f2;
    }
  }
}

.bg {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
}

.is-blancozone {
  .container,
  .container-wrapper {
    border-radius: 10px;
  }
  .btn-wrap {
    .btn {
      width: 200px;
      height: 48px;
      line-height: 48px;
      background-color: #b4d7fb;
      border: 1px solid #fff;
      color: #fff;
      border-radius: 40px;
      &.confirm {
        background-color: #fff;
        border: 1px solid #b4d7fb;
        color: #b4d7fb;
      }
    }
  }
}

@media screen and (orientation: landscape) {
  .container {
    transform: scale(0.7);
  }
}
</style>
